import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { HomeComponent } from './../home/home.component';
import { AboutusComponent } from './../aboutus/aboutus.component';
import { ManufacturingComponent } from './../manufacturing/manufacturing.component';
import { RestaurantorderbookingComponent } from './../restaurantorderbooking/restaurantorderbooking.component';
import { RestauranttablecountersaleComponent } from './../restauranttablecountersale/restauranttablecountersale.component';
import { RetailmanagementComponent } from './../retailmanagement/retailmanagement.component';
import { SchoolmanagementComponent } from './../schoolmanagement/schoolmanagement.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'aboutus', component: AboutusComponent },
            { path: 'manufacturing', component: ManufacturingComponent },
            { path: 'restaurant-order-booking-delievery', component: RestaurantorderbookingComponent },
            { path: 'restaurant-table-counter-sale', component: RestauranttablecountersaleComponent },
            { path: 'retail-management', component: RetailmanagementComponent },
            { path: 'school-management', component: SchoolmanagementComponent }
        ])
    ],
    declarations: [],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/app/app-routing/app-routing.module.ts